import React from 'react';
import styles from './index.module.scss';

// Cột phải mặc định là ảnh minh hoạ. Truyền `aside` để thay ảnh bằng nội dung khác
// (màn tra cứu bảo hành dùng chỗ này để hiện kết quả ngay tại chỗ, không chuyển màn).
//
// `equalColumns`: bố cục padding 2 bên + gap cố định, phần còn lại chia đôi cho 2 cột.
// Mặc định (không truyền) là 42.5%/42.5% + space-evenly của màn tra cứu đơn hàng.
const LookupFormLayout = ({ title, note, illustration, illustrationAlt, aside, equalColumns, children }) => {
  const containerClass = [
    styles['container'],
    equalColumns ? styles['equal-columns'] : '',
    aside ? styles['has-aside'] : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={containerClass}>
      <div className={styles['form']}>
        <div className={styles['title']}>{title}</div>
        <div className={styles['note']}>{note}</div>
        {children}
      </div>
      {aside ? (
        <div className={styles['aside']}>{aside}</div>
      ) : (
        // Khung riêng để ảnh có thể bị chặn max-width mà cột vẫn giữ đúng bề rộng:
        // đặt max-width thẳng lên flex item sẽ khiến nó bị đóng băng và form ăn mất phần dư.
        <div className={styles['illustration-wrap']}>
          <img src={illustration} alt={illustrationAlt} className={styles['illustration']} />
        </div>
      )}
    </div>
  );
};

export default LookupFormLayout;
